import React, { useEffect, useState } from "react";
import {
  Container,
  TextField,
  Typography,
  Grid,
  Button,
  IconButton,
  Box,
  Paper,
  InputAdornment,
  FormControlLabel,
  Checkbox
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
import { useForm, Controller } from "react-hook-form";
import CryptoJS from "crypto-js";
import AtithiLogo from "../../../assets/Atithiseva-Logo-Final-1024x298.png";
import "../../../styles/LoginForm.css";
import { useDispatch, useSelector } from "react-redux";
import { loginRequest, resetLoginFormState } from "../actions/authActions";
import {
  DASHBOARD,
  FORGOT_PASSWORD,
  VENDOR_DASHBOARD
} from "../../../component/common/Routes/AppRoutes";
import TextInputField from "../../../component/ui/FormFields/TextInputField";
import { useSelect } from "@mui/base";
import { CUSTOMER_DASHBOARD } from "../../../component/common/Routes/CustomerRoutes";
import CustomButton from "../../../component/ui/FormFields/Button";
import { toast, ToastContainer } from "react-toastify";

const SECRET_KEY = "843567893696976453275974432697R634976";
export default function LoginForm() {
  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm();

  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const error = useSelector((state) => state.auth.error);
  const accessToken = useSelector((state) => state.auth.accessToken);

  const refreshToken = useSelector((state) => state.auth.refreshToken);
  const loading = useSelector((state) => state?.auth?.loading);

  const success = useSelector((state) => state.auth?.success);

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = async (data) => {
    dispatch(loginRequest(data));

    localStorage.setItem("userEmail", data.email);
  };
  useEffect(() => {
    dispatch(resetLoginFormState());
  }, []);
  useEffect(() => {
    if (success) {
      toast.success("Logged In SuccessFully", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetLoginFormState());
          //  switch (user?.role) {
          //    case 'Admin':
          //      navigate(DASHBOARD);
          //      break;
          //    case 'Staff':
          //      navigate(DASHBOARD);
          //      break;
          //    case 'Vendor':
          //      navigate(VENDOR_DASHBOARD);
          //      break;
          //    case 'Customer':
          //      navigate(CUSTOMER_DASHBOARD);
          //      break;
          //    default:
          //      navigate('/');
          //  }
        }
      });
    }
  }, [success]);
  useEffect(() => {
    if (error) {
      toast.error(error, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetLoginFormState());
        }
      });
    }
  }, [error]);

  useEffect(() => {
    if (accessToken && refreshToken) {
      const encryptedAccessToken = CryptoJS.AES.encrypt(
        accessToken,
        SECRET_KEY
      ).toString();
      const encryptedRefreshToken = CryptoJS.AES.encrypt(
        refreshToken,
        SECRET_KEY
      ).toString();
      localStorage.setItem("accessToken", encryptedAccessToken);
      localStorage.setItem("refreshToken", encryptedRefreshToken);
    }
  }, [user, accessToken, refreshToken, error, navigate]);

  return (
    <>
      <ToastContainer />
      <Box className="login-container">
        <Container maxWidth="sm">
          <Paper className="login-paper" elevation={4}>
            <Box>
              <img
                src={AtithiLogo}
                alt="Atithiseva Logo"
                className="login-logo"
              />
            </Box>
            <Typography variant="h4" className="login-title">
              Login
            </Typography>

            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Controller
                    name="email"
                    control={control}
                    defaultValue=""
                    rules={{
                      required: "Username or Email is required",
                      pattern: {
                        value: /^\S+@\S+\.com$/i,
                        message: "Enter a valid email address"
                      }
                    }}
                    render={({ field }) => (
                      <TextInputField
                        {...field}
                        label="Username or Email"
                        placeholder="Enter your username or email"
                        fullWidth
                        error={!!errors.email}
                        helperText={errors.email?.message}
                        startAdornment={
                          <InputAdornment position="start">
                            <AccountCircleIcon />
                          </InputAdornment>
                        }
                        inputProps={{
                          autoComplete: "username"
                        }}
                        variant="outlined"
                        className="text-field"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="password"
                    control={control}
                    defaultValue=""
                    rules={{
                      required: "Password is required",
                      minLength: {
                        value: 6,
                        message: "Password must be at least 6 characters"
                      }
                    }}
                    render={({ field }) => (
                      <TextInputField
                        {...field}
                        label="Password"
                        placeholder="Enter your password"
                        type={showPassword ? "text" : "password"}
                        fullWidth
                        error={!!errors.password}
                        helperText={errors.password?.message}
                        startAdornment={
                          <InputAdornment position="start">
                            <LockIcon />
                          </InputAdornment>
                        }
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword((prev) => !prev)}
                              edge="end"
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        inputProps={{
                          autoComplete: "current-password"
                        }}
                        variant="outlined"
                        className="text-field"
                      />
                    )}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <FormControlLabel
                    control={<Checkbox color="primary" />}
                    label="Remember Me"
                  />
                  <Link to={FORGOT_PASSWORD} className="forgot-password-link">
                    Forgot Password?
                  </Link>
                </Grid>

                <Grid item xs={12}>
                  <CustomButton
                    variant="contained"
                    className="success-button"
                    type="submit"
                    fullwidth={true}
                    loading={loading}
                    text={"Login"}
                  />
                  {/* <Button
                  type='submit'
                  variant='contained'
                  fullWidth
                  size='large'
                  className='login-button'
                >
                  LogIn
                </Button> */}
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Container>
      </Box>
    </>
  );
}
